import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="cms-user-form"
export default class extends Controller {
  static targets = ['borough', 'homeSite']

  connect() {
  }

  updateHomeSites(event) {
    let boroughId = this.boroughTarget.selectedOptions[0].value;
    fetch(`/library/api/boroughs/${boroughId}/prism_home_sites`)
    .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok (status: ${response.status})`);
        }
        return response.json(); 
      })
    .then(data => {
        this.homeSiteTarget.innerHTML = '';
        data.forEach(location => {
          console.log(location);
          let option = document.createElement('option');
          option.value = location.id;
          option.text = location.prism_id;
          this.homeSiteTarget.appendChild(option);
        });
      })
    .catch(error => {
        console.error("Error fetching or parsing data:", error);
      });
  }
}

